import { h, render, Component } from 'preact';

const Location = (props) =>{
	return(
		<svg viewBox="0 0 72 72" class={props.class}>
			<g>
	<path d="M36,71c-1.45,0-2.81-0.64-3.73-1.75c-7-8.44-23.3-29.36-23.3-41.22C8.97,13.13,21.1,1,36,1s27.03,12.12,27.03,27.03
		c0,11.86-16.29,32.78-23.3,41.22C38.81,70.36,37.45,71,36,71z M36,6c-12.15,0-22.03,9.88-22.03,22.03c0,8.33,11.36,25,22.03,37.89
		c10.67-12.89,22.03-29.56,22.03-37.89C58.03,15.88,48.15,6,36,6z M36,36.49c-6.13,0-11.12-4.99-11.12-11.12
		c0-6.13,4.99-11.12,11.12-11.12s11.12,4.99,11.12,11.12C47.12,31.51,42.13,36.49,36,36.49z M36,19.26c-3.37,0-6.12,2.74-6.12,6.12
		c0,3.37,2.74,6.12,6.12,6.12s6.12-2.74,6.12-6.12C42.12,22,39.37,19.26,36,19.26z"/>
</g>
		</svg>
	)
}
export default Location;


// WEBPACK FOOTER //
// ../q-components/components/icons/location/index.js